import classNames from "classnames";
import { reportContentBottom, reportContentTop } from "./config";
import classes from "./report-content.module.scss";

export const ReportContent = () => {
    return (
        <div className={classes["report-content"]}>
            <h2 className={classes["report-content__title"]}>Что в отчете</h2>
            <div className={classes["report-content__inner"]}>
                <div className={classes["report-content__top"]}>
                    {reportContentTop.map((card) => (
                        <div
                            key={card.id}
                            className={classNames(
                                classes["report-content__card"],
                                classes[`report-content__card--${card.id}`]
                            )}
                        >
                            <h3 className={classes["report-content__subtitle"]}>{card.title}</h3>
                            <p
                                className={classNames(
                                    classes["report-content__text"],
                                    classes[`report-content__text--${card.id}`]
                                )}
                            >
                                {card.text}
                            </p>
                        </div>
                    ))}
                </div>
                <div className={classes["report-content__bottom"]}>
                    {reportContentBottom.map((card) => (
                        <div
                            key={card.id}
                            className={classNames(
                                classes["report-content__card"],
                                classes[`report-content__card--${card.id}`]
                            )}
                        >
                            <h3 className={classes["report-content__subtitle"]}>{card.title}</h3>
                            <p className={classes["report-content__text"]}>{card.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};